export default __webpack_public_path__ + "static/media/screen_whatsapp_2.6034ef94.png";